module.exports = __webpack_public_path__ + "static/img/normal_u75.d0048f40.svg";